module.exports = __webpack_public_path__ + "img/golden-hunter-black.dbb48d40.jpg";